import { h } from "preact";
import { useState } from "preact/hooks";
import { useNavigate } from "react-router-dom";
import axios from "axios";


export default function FakeLoginPage(props) {

    const [consumer_id, setConsumerId] = useState("");
    const [consumer_role, setConsumerRole] = useState("");
    const navigate = useNavigate();

    const handleConsumerIdInputChange = (event) => {
        setConsumerId(event.target.value);
    }

    const handleConsumerRoleInputChange = (event) => {
        setConsumerRole(event.target.value);
    }

    const handleFormSubmition = (event) => {

        event.preventDefault();

        axios.post(`auth/authenticate`, {
            consumer_id: consumer_id,
            consumer_role: consumer_role
        }).then((res) => {
            if (res.status === 200) {
                localStorage.setItem("access-token", res.data);
                navigate("/");
                console.log(`Saved access-token ${res.data}`)
            } else {
                throw new Error(res.error);
            }
        }).catch((err) => {
            console.error(err);
            alert("Error logging in please try again");
        });
    }

    return (
        <section className="hero is-fullheight">
            <div className="hero-body">
                <div className="container">
                    <div className="columns is-centered is-vcentered">
                        <div className="column is-half">
                            <h1 className="title">
                                <i className="fa fa-shield" />
                                &nbsp;LOGIN
                            </h1>
                            <form onSubmit={handleFormSubmition}>
                                <div className="field">
                                    <p className="control has-icons-left has-icons-right">
                                        <input
                                            name="cid"
                                            className="input"
                                            type="text"
                                            placeholder="consumer id"
                                            onChange={handleConsumerIdInputChange}
                                            required
                                        />
                                        <span className="icon is-small is-left">
                                            <i className="fa fa-id-badge"></i>
                                        </span>
                                    </p>
                                </div>
                                <div className="field">
                                    <p className="control has-icons-left">
                                        <input
                                            name="role"
                                            className="input"
                                            type="test"
                                            placeholder="role"
                                            onChange={handleConsumerRoleInputChange}
                                            required
                                        />
                                        <span className="icon is-small is-left">
                                            <i className="fa fa-lock"></i>
                                        </span>
                                    </p>
                                </div>
                                <div className="field">
                                    <p className="control">
                                        <input
                                            className="button is-fullwidth is-info has-text-weight-bold"
                                            type="submit"
                                            value="LOG IN"
                                        />
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
